import {
  ActionList,
  AnimatedElement,
  Box,
  ErrorBoundary,
  Separator,
} from "@prismicio/editor-ui"
import { Suspense } from "react"

import {
  ListMenuItemSkeleton,
  SettingPermissionMenuItems,
  SharedOnboardingGuideMenuItem,
} from "../documents/DocumentListSidePanel/DocumentListMenu"
import { LeftSidePanelLayout } from "../documents/DocumentListSidePanel/DocumentListSidePanel"
import { getMasterLocale } from "../settings/locales/localeUtils"
import { useRepositoryLocalesQuery } from "../settings/locales/useRepositoryLocales"

export function OnboardingSideMenu() {
  const { data: repositoryLocales } = useRepositoryLocalesQuery()
  const masterLocale = getMasterLocale(repositoryLocales)

  return (
    <LeftSidePanelLayout>
      <Box flexDirection="column" flexGrow={1} justifyContent="end">
        <ActionList variant="borderless">
          <ErrorBoundary>
            <Suspense fallback={<ListMenuItemSkeleton count={1} />}>
              <SharedOnboardingGuideMenuItem />
            </Suspense>
          </ErrorBoundary>
          <AnimatedElement animation={{ name: "fade" }}>
            {masterLocale && (
              <>
                <Separator
                  style="dashed"
                  sx={{ marginTop: 8, marginBottom: 8 }}
                />
                <ErrorBoundary>
                  <Suspense fallback={<ListMenuItemSkeleton count={1} />}>
                    <SettingPermissionMenuItems />
                  </Suspense>
                </ErrorBoundary>
              </>
            )}
          </AnimatedElement>
        </ActionList>
      </Box>
    </LeftSidePanelLayout>
  )
}
